import { useEffect, useState } from 'react';
import { getCurrentUser, changePassword } from '../services/adminApi';

const MIN_LENGTH = 8;

export default function Account() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [reveal, setReveal] = useState(false);

  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    getCurrentUser().then(({ user }) => {
      setUser(user);
      setLoading(false);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      return setError('Please fill in all three fields.');
    }
    if (newPassword.length < MIN_LENGTH) {
      return setError(`New password must be at least ${MIN_LENGTH} characters.`);
    }
    if (newPassword !== confirmPassword) {
      return setError('New password and confirmation do not match.');
    }
    if (newPassword === currentPassword) {
      return setError('New password must be different from the current one.');
    }

    setBusy(true);
    const { error } = await changePassword({
      email: user.email,
      currentPassword,
      newPassword,
    });
    setBusy(false);

    if (error) {
      setError(error.message);
      return;
    }

    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setSuccess('Password updated. Use your new password next time you sign in.');
  };

  if (loading) return <div className="admin-table-state">Loading account…</div>;

  return (
    <div>
      <div className="page-head">
        <h1>Account</h1>
      </div>

      {/* Signed-in identity */}
      <div className="account-card">
        <h2>Signed in as</h2>
        <div className="account-meta">
          <div>
            <span className="account-label">Email</span>
            <span className="account-value">{user?.email || '—'}</span>
          </div>
          <div>
            <span className="account-label">Last sign in</span>
            <span className="account-value">
              {user?.last_sign_in_at
                ? new Date(user.last_sign_in_at).toLocaleString('en-IN', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })
                : '—'}
            </span>
          </div>
        </div>
      </div>

      {/* Change password */}
      <div className="account-card">
        <h2>Change Password</h2>
        <p className="account-hint">
          You'll need your current password to confirm it's you.
        </p>

        <form className="admin-form account-form" onSubmit={handleSubmit}>
          <label>
            Current Password
            <input
              type={reveal ? 'text' : 'password'}
              value={currentPassword}
              autoComplete="current-password"
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          </label>

          <label>
            New Password
            <input
              type={reveal ? 'text' : 'password'}
              value={newPassword}
              autoComplete="new-password"
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder={`At least ${MIN_LENGTH} characters`}
            />
          </label>

          <label>
            Confirm New Password
            <input
              type={reveal ? 'text' : 'password'}
              value={confirmPassword}
              autoComplete="new-password"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </label>

          <label className="check">
            <input
              type="checkbox"
              checked={reveal}
              onChange={(e) => setReveal(e.target.checked)}
            />
            Show passwords
          </label>

          {error && <p className="admin-error">{error}</p>}
          {success && <p className="admin-success">{success}</p>}

          <div className="admin-modal-actions">
            <button type="submit" className="btn-primary" disabled={busy}>
              {busy ? 'Updating…' : 'Update Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
